const shoeSizes = ["35", "36", "37", "38", "39", "40", "41", "42"];
const unisexSizes = [...shoeSizes, "43", "44", "45", "46"];

const createImages = (id) => {
  const number = String(id).padStart(2, "0");
  return [
    `/img/products/product-${number}.jpg`,
    `/img/products/product-${number}-detail.jpg`,
    `/img/products/product-${number}-alt.jpg`,
  ];
};

const createVariantImages = (id) => {
  return createImages(id + 16);
};

const productData = [
  {
    id: 1,
    name: "Low-Top Merlot",
    category: "Sneakers",
    price: 175,
    images: createImages(1),
    description:
      "A burgundy low-top sneaker with subtle floral embroidery. Its flexible sole and padded collar provide everyday comfort.",
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "Runs slightly small",
    },
    size: shoeSizes,
    colors: ["Burgundy"],
    tags: ["sneakers", "embroidered", "low-top"],
    badge: "New",
    rating: 4.8,
    reviews: 84,
  },
  {
    id: 2,
    name: "Court White",
    category: "Sneakers",
    price: 180,
    images: createImages(2),
    description:
      "A clean white sneaker with a caramel accent panel. An easy-to-style silhouette with a cushioned insole.",
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: shoeSizes,
    colors: ["White", "Caramel"],
    tags: ["sneakers", "white", "everyday"],
    rating: 4.7,
    reviews: 62,
  },
  {
    id: 3,
    name: "Court Black",
    category: "Sneakers",
    price: 180,
    images: createImages(3),
    description:
      "A minimalist black sneaker on a cream sole. Its understated profile works with both casual and smarter looks.",
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: shoeSizes,
    colors: ["Black", "Cream"],
    tags: ["sneakers", "black", "minimalist"],
    rating: 4.7,
    reviews: 58,
  },
  {
    id: 4,
    name: "Retro Hazel",
    category: "Sneakers",
    price: 195,
    images: createImages(4),
    description:
      "A retro-inspired sneaker with hazel and plum panels. Its dynamic profile and light cushioning suit long days.",
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: unisexSizes,
    colors: ["Hazel", "Plum"],
    tags: ["sneakers", "retro", "unisex"],
    badge: "Best-seller",
    rating: 4.9,
    reviews: 105,
  },
  {
    id: 5,
    name: "City Loafer Cocoa",
    category: "Loafers & Derbies",
    price: 190,
    images: createImages(5),
    description:
      "A chocolate loafer with a lug sole, designed to combine support, stability and a city-ready look.",
    attributes: {
      material: "Velvet-effect microfibre",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: shoeSizes,
    colors: ["Chocolate"],
    tags: ["loafer", "urban", "lug sole"],
    rating: 4.6,
    reviews: 43,
  },
  {
    id: 6,
    name: "Polished Derby",
    category: "Loafers & Derbies",
    price: 205,
    images: createImages(6),
    description:
      "A polished black Derby with clean lines. The substantial sole and low heel create a stable base without weighing down the silhouette.",
    attributes: {
      material: "Coated microfibre",
      origin: "See product label",
      sole: "Rubber",
      fit: "Runs slightly large",
    },
    size: shoeSizes,
    colors: ["Glossy black"],
    tags: ["derby", "glossy", "city"],
    rating: 4.8,
    reviews: 39,
  },
  {
    id: 7,
    name: "Block Heel Amber",
    category: "Boots",
    price: 210,
    images: createImages(7),
    description:
      "An amber ankle boot built around a block heel. A side fastening makes it easy to put on, while the rounded toe adds room.",
    attributes: {
      material: "Microfibre",
      origin: "See product label",
      sole: "Non-slip rubber",
      fit: "True to size",
    },
    size: shoeSizes,
    colors: ["Amber"],
    tags: ["ankle boot", "block heel", "city"],
    badge: "Featured",
    compareAtPrice: 220,
    rating: 4.7,
    reviews: 51,
  },
  {
    id: 8,
    name: "Round-Toe Wine",
    category: "Heels & Flats",
    price: 185,
    images: createImages(8),
    description:
      "A burgundy strap shoe with a stable heel and rounded toe. A versatile style for day or evening.",
    attributes: {
      material: "Microfibre",
      origin: "See product label",
      sole: "Non-slip rubber",
      fit: "True to size",
    },
    size: shoeSizes,
    colors: ["Burgundy"],
    tags: ["strap", "heel", "smart"],
    rating: 4.8,
    reviews: 47,
  },
  {
    id: 9,
    name: "Flex Sage",
    category: "Flexible Shoes",
    price: 175,
    images: createImages(9),
    description:
      "A flexible sage sneaker with a wide toe box, designed to provide extra room and support natural foot movement.",
    attributes: {
      material: "Breathable textile and microfibre",
      origin: "See product label",
      sole: "Slim and flexible",
      fit: "Wide fit",
    },
    size: unisexSizes,
    colors: ["Sage"],
    tags: ["flexible", "unisex", "wide"],
    badge: "New",
    rating: 4.7,
    reviews: 29,
  },
  {
    id: 10,
    name: "Flex Sand",
    category: "Flexible Shoes",
    price: 175,
    images: createImages(10),
    description:
      "The sand version of our flexible sneaker. Its lightweight construction and low profile prioritise freedom of movement.",
    attributes: {
      material: "Textile and microfibre",
      origin: "See product label",
      sole: "Flexible rubber",
      fit: "Wide fit",
    },
    size: unisexSizes,
    colors: ["Sand"],
    tags: ["flexible", "neutral", "unisex"],
    rating: 4.6,
    reviews: 24,
  },
  {
    id: 11,
    name: "Vintage Panel",
    category: "Sneakers",
    price: 190,
    images: createImages(11),
    description:
      "A white sneaker with denim blue, brick and cream panels. Its retro tennis-inspired construction adds a graphic touch.",
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: unisexSizes,
    colors: ["White", "Blue", "Brick"],
    tags: ["sneakers", "retro", "unisex"],
    rating: 4.8,
    reviews: 64,
  },
  {
    id: 12,
    name: "Mono Cobalt",
    category: "Sneakers",
    price: 185,
    images: createImages(12),
    description:
      "A monochrome cobalt sneaker with a minimalist profile. The gum sole provides grip while the padded upper supports the foot.",
    attributes: {
      material: "Textile and microfibre",
      origin: "See product label",
      sole: "Gum rubber",
      fit: "True to size",
    },
    size: unisexSizes,
    colors: ["Cobalt blue"],
    tags: ["sneakers", "blue", "unisex"],
    badge: "New",
    rating: 4.6,
    reviews: 31,
  },
  {
    id: 13,
    name: "High-Top Mocha",
    category: "Sneakers",
    price: 200,
    images: createImages(13),
    description:
      "A mocha high-top sneaker with a padded collar and contrasting sole. A comfortable option for cooler days.",
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: unisexSizes,
    colors: ["Mocha"],
    tags: ["high-top", "unisex", "everyday"],
    rating: 4.7,
    reviews: 42,
  },
  {
    id: 14,
    name: "Strap Flat Ivory",
    category: "Heels & Flats",
    price: 180,
    images: createImages(14),
    description:
      "An ivory flat with a slim strap and softly squared toe. Its cushioned insole provides comfort throughout the day.",
    attributes: {
      material: "Microfibre",
      origin: "See product label",
      sole: "Slim and non-slip",
      fit: "True to size",
    },
    size: shoeSizes,
    colors: ["Ivory"],
    tags: ["flat", "strap", "flat sole"],
    rating: 4.8,
    reviews: 36,
  },
  {
    id: 15,
    name: "Slim Heel Plum",
    category: "Sandals",
    price: 185,
    images: createImages(15),
    description:
      "A plum sandal with slim straps and a low, stable heel. Its light profile suits dressed-up occasions and summer outings.",
    attributes: {
      material: "Microfibre",
      origin: "See product label",
      sole: "Non-slip rubber",
      fit: "True to size",
    },
    size: shoeSizes,
    colors: ["Plum"],
    tags: ["sandal", "heel", "summer"],
    compareAtPrice: 205,
    rating: 4.7,
    reviews: 34,
  },
  {
    id: 16,
    name: "Woven Sandal Tan",
    category: "Sandals",
    price: 175,
    images: createImages(16),
    description:
      "An open, lightweight woven sandal in tan. The adjustable back strap and flat sole support a stable stride.",
    attributes: {
      material: "Woven microfibre",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: shoeSizes,
    colors: ["Tan"],
    tags: ["sandal", "woven", "flat sole"],
    rating: 4.6,
    reviews: 27,
  },
  {
    id: 17,
    name: "Floral Low Merlot",
    category: "Sneakers",
    price: 185,
    images: createVariantImages(1),
    description:
      "A burgundy low-top sneaker with floral details, a soft collar and a contrasting light sole.",
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "Runs slightly small",
    },
    size: shoeSizes,
    colors: ["Merlot"],
    tags: ["sneakers", "floral", "low-top"],
    rating: 4.7,
    reviews: 38,
  },
  {
    id: 18,
    name: "Clean Court Caramel",
    category: "Sneakers",
    price: 190,
    images: createVariantImages(2),
    description:
      "A white court sneaker finished with a caramel accent panel and a comfortable sole.",
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: shoeSizes,
    colors: ["White", "Caramel"],
    tags: ["sneakers", "court", "low-top"],
    badge: "New",
    rating: 4.8,
    reviews: 41,
  },
  {
    id: 19,
    name: "Night Court Cream",
    category: "Sneakers",
    price: 190,
    images: createVariantImages(3),
    description:
      "A black sneaker with a cream sole, designed for an understated and easy-to-wear look.",
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: shoeSizes,
    colors: ["Black", "Cream"],
    tags: ["sneakers", "black", "city"],
    rating: 4.6,
    reviews: 33,
  },
  {
    id: 20,
    name: "Panel Runner Hazel",
    category: "Sneakers",
    price: 205,
    images: createVariantImages(4),
    description:
      "A retro sneaker with contrasting panels and a stable base for active days.",
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: unisexSizes,
    colors: ["Hazel", "Plum"],
    tags: ["sneakers", "retro", "unisex"],
    rating: 4.8,
    reviews: 57,
  },
  {
    id: 21,
    name: "Platform Loafer Cocoa",
    category: "Loafers & Derbies",
    price: 200,
    images: createVariantImages(5),
    description:
      "A chocolate loafer with a substantial sole and a structured profile suited to city dressing.",
    attributes: {
      material: "Velvet-effect microfibre",
      origin: "See product label",
      sole: "Lugged rubber",
      fit: "True to size",
    },
    size: shoeSizes,
    colors: ["Cocoa"],
    tags: ["loafer", "platform", "city"],
    rating: 4.7,
    reviews: 35,
  },
  {
    id: 22,
    name: "Gloss Derby Black",
    category: "Loafers & Derbies",
    price: 215,
    images: createVariantImages(6),
    description:
      "A glossy black Derby with tonal laces and a sturdy sole for stable support.",
    attributes: {
      material: "Coated microfibre",
      origin: "See product label",
      sole: "Rubber",
      fit: "Runs slightly large",
    },
    size: shoeSizes,
    colors: ["Black"],
    tags: ["derby", "laces", "glossy"],
    rating: 4.8,
    reviews: 44,
  },
  {
    id: 23,
    name: "Amber Ankle Boot",
    category: "Boots",
    price: 220,
    images: createVariantImages(7),
    description:
      "An amber ankle boot with a block heel and side fastening, designed for a clean silhouette.",
    attributes: {
      material: "Microfibre",
      origin: "See product label",
      sole: "Non-slip rubber",
      fit: "True to size",
    },
    size: shoeSizes,
    colors: ["Amber"],
    tags: ["ankle boot", "block heel", "autumn"],
    badge: "New",
    rating: 4.7,
    reviews: 31,
  },
  {
    id: 24,
    name: "Mary Jane Burgundy",
    category: "Heels & Flats",
    price: 195,
    images: createVariantImages(8),
    description:
      "A burgundy Mary Jane-inspired strap shoe with a rounded toe and stable heel.",
    attributes: {
      material: "Microfibre",
      origin: "See product label",
      sole: "Non-slip rubber",
      fit: "True to size",
    },
    size: shoeSizes,
    colors: ["Burgundy"],
    tags: ["mary jane", "strap", "heel"],
    rating: 4.8,
    reviews: 46,
  },
  {
    id: 25,
    name: "Wide Flex Olive",
    category: "Flexible Shoes",
    price: 180,
    images: createVariantImages(9),
    description:
      "A flexible olive sneaker with a wide toe box and slim sole for greater freedom of movement.",
    attributes: {
      material: "Breathable textile and microfibre",
      origin: "See product label",
      sole: "Slim and flexible",
      fit: "Wide fit",
    },
    size: unisexSizes,
    colors: ["Olive"],
    tags: ["flexible", "wide", "unisex"],
    rating: 4.6,
    reviews: 26,
  },
  {
    id: 26,
    name: "Wide Flex Oat",
    category: "Flexible Shoes",
    price: 180,
    images: createVariantImages(10),
    description:
      "A flexible oat-coloured sneaker with a low profile, tonal laces and a flexible sole.",
    attributes: {
      material: "Textile and microfibre",
      origin: "See product label",
      sole: "Flexible rubber",
      fit: "Wide fit",
    },
    size: unisexSizes,
    colors: ["Oat"],
    tags: ["flexible", "neutral", "unisex"],
    rating: 4.7,
    reviews: 30,
  },
  {
    id: 27,
    name: "Heritage Court Multi",
    category: "Sneakers",
    price: 200,
    images: createVariantImages(11),
    description:
      "A retro court sneaker combining white, blue and brick in a graphic panelled design.",
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: unisexSizes,
    colors: ["White", "Blue", "Brick"],
    tags: ["sneakers", "multicolour", "retro"],
    rating: 4.8,
    reviews: 52,
  },
  {
    id: 28,
    name: "Cobalt Street Low",
    category: "Sneakers",
    price: 195,
    images: createVariantImages(12),
    description:
      "A cobalt low-top sneaker with a gum sole, monochrome silhouette and padded collar.",
    attributes: {
      material: "Textile and microfibre",
      origin: "See product label",
      sole: "Gum rubber",
      fit: "True to size",
    },
    size: unisexSizes,
    colors: ["Cobalt"],
    tags: ["sneakers", "monochrome", "unisex"],
    badge: "Featured",
    rating: 4.6,
    reviews: 28,
  },
  {
    id: 29,
    name: "Mocha High Street",
    category: "Sneakers",
    price: 210,
    images: createVariantImages(13),
    description:
      "A mocha high-top sneaker with a padded ankle and contrasting light sole.",
    attributes: {
      material: "Microfibre and textile",
      origin: "See product label",
      sole: "Rubber",
      fit: "True to size",
    },
    size: unisexSizes,
    colors: ["Mocha"],
    tags: ["high-top", "sneakers", "unisex"],
    rating: 4.7,
    reviews: 37,
  },
  {
    id: 30,
    name: "Ivory Square Flat",
    category: "Heels & Flats",
    price: 190,
    images: createVariantImages(14),
    description:
      "An ivory flat with a softly squared toe, slim strap and cushioned insole.",
    attributes: {
      material: "Microfibre",
      origin: "See product label",
      sole: "Slim and non-slip",
      fit: "True to size",
    },
    size: shoeSizes,
    colors: ["Ivory"],
    tags: ["flat", "flat sole", "strap"],
    rating: 4.8,
    reviews: 40,
  },
];

const footwearData = productData.map((product) => ({
  ...product,
  category: "Shoes & Boots",
}));

export default footwearData;
